module.exports = __webpack_public_path__ + "static/media/drilldown.5d68dfc0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Twitch/Preview/img/drilldown.mp4
// module id = 219
// module chunks = 0